import React, {useState, useRef} from "react";
import './casestudy.scss';
import TeamData from "../Team/TeamData";

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
 
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

// import required modules
import { EffectCreative, FreeMode, Navigation, Thumbs } from 'swiper/modules';
import { image } from "../../Assets";


const CaseStudy =()=> {

    const prevRef = useRef(null);
        const nextRef = useRef(null);

    return(
        <>
            <section className="case-studies-section">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="title">
                                <h2>Case Studies</h2>    
                            </div>                        
                        </div>
                    </div>
                </div>

                <div className="container" style={{paddingTop:'40px'}}>
                    <div className="row">
                        <div className='col-12 col-lg-12 slider'>                                    
                            <div className='team-slider'>
                                <Swiper
                                    style={{
                                    '--swiper-navigation-color': '#fff',
                                    '--swiper-pagination-color': '#fff',
                                    }}
                                    loop={true}
                                    spaceBetween={100}
                                    navigation={{
                                    prevEl: prevRef.current,
                                    nextEl: nextRef.current,
                                    }}
                                    onInit={(swiper) => {
                                    swiper.params.navigation.prevEl = prevRef.current;
                                    swiper.params.navigation.nextEl = nextRef.current;
                                    swiper.navigation.init();
                                    swiper.navigation.update();
                                    }}
                                    centeredSlides={true}
                                    autoplay={{delay:4000,disableOnInteraction:false,pauseOnMouseEnter: false,}}  
                                    modules={[FreeMode, Navigation, Thumbs, EffectCreative]}
                                    className="mySwiper2"
                                >
                                    {TeamData.map((obj)=>{
                                        return(
                                        <>
                                            <SwiperSlide> 
                                                <div className="row" key={obj.id}>     
                                                    <div className="col-xl-4 col-lg-4 col-12">
                                                        <div className="swiper-head">
                                                            <h2>O’Hare International Airport Terminal 3 Improvements</h2>
                                                        </div>
                                                        <div>  
                                                            <div className="tw-pb-4">    
                                                                <p>Fractile provides customized rich rendering solutions in both 2D and 3D environments, utilizing multiple mediums to enhance user experience and decision-making capabilities.</p>
                                                            </div>  
                                                            <button className="btn-2">
                                                                <a href="/team">View Case Studies</a>
                                                            </button>
                                                        </div>
                                                    </div>                                               
                                                    <div className="col-xl-8 col-lg-7 col-lg-8 col-12">                                                        
                                                        <img src={image.caseStudies1} alt="" style={{width:'90%',float:'right'}} />
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                        </>
                                        )
                                    })} 
                                    
                                    <div className="swipercustombtn">
                                        <button ref={prevRef} style={{  border: 'none', cursor: 'pointer',zIndex:'9' }}>                                        
                                            <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.1201 0.707031L1.41422 7.41291L8.1201 14.1188" stroke="#ffffff" stroke-width="2"/>
                                            </svg>
                                        </button>
                                        <button ref={nextRef} style={{ border: 'none', cursor: 'pointer' }}>
                                            <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.707108 0.707031L7.41299 7.41291L0.707108 14.1188" stroke="#ffffff" stroke-width="2"/>
                                            </svg>
                                        </button>
                                    </div>                                   
                                </Swiper>                                                                                          
                            </div>                    
                        </div>                        
                    </div>
                </div>
            </section>
        </>
    )
}

export default CaseStudy;